import common from './it/pages/common';
import dashboard from './it/pages/dashboard';
import account from './it/pages/account';
import vendors from './it/pages/vendors';
import auth from './it/pages/auth';
import guests from './it/pages/guests';
import budget from './it/pages/budget';
import timeline from './it/pages/timeline';
import subscription from './it/pages/subscription';
import events from './it/pages/events';
import notifications from './it/pages/notifications';
import theme from './it/theme';
import invitation from './it/pages/invitation';
import collaborators from './it/pages/collaborators';
import languages from './it/pages/languages';
import access from './it/pages/access';
import settings from './it/pages/settings';

import legal from './it/pages/legal';
import achievements from './it/pages/achievements';
import taskTemplates from './it/taskTemplates';
import debug from './it/debug';

export default {
  ...common,
  common,
  currentEvent: "Evento attuale",
  dashboard,
  account,
  vendors,
  auth,
  guests,
  budget,
  timeline,
  subscription,
  events,
  notifications,
  theme: {
    ...theme,
    light: "Chiaro",
    dark: "Scuro",
    system: "Sistema"
  },
  invitation,
  collaborators,
  languages,
  access,
  ...settings,
  legal,
  achievements,
  taskTemplates,
  debug
};
